import styled from 'styled-components'

interface IRadioGroupStyledProps {}

export const RadioGroupStyled = styled.div<IRadioGroupStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .group-value-input {
    display: none;
  }
`
